import { createContext, useContext } from 'react'
import { useTranslation } from 'react-i18next'
import { Button } from '@/components/ui/button'
import type { PosCashStatus } from './types'

export interface CashRegisterContextValue {
  status: PosCashStatus | undefined
  unavailable: boolean
  open: () => void
}
export const CashRegisterContext = createContext<CashRegisterContextValue | null>(null)
export const useCashRegister = () => useContext(CashRegisterContext)
export function CashRegisterNotice() {
  const { t } = useTranslation('posOrdering')
  const cash = useCashRegister()
  if (!cash || (!cash.unavailable && cash.status?.session?.state === 'open')) return null
  return <div className="flex flex-wrap items-center justify-between gap-2 text-sm" role="status">
    <span>{t(cash.unavailable || !cash.status ? 'cash.unavailable' : cash.status.session?.state === 'counting' ? 'cash.countingNotice' : 'cash.openRequired')}</span>
    <Button variant="outline" className="h-11" onClick={cash.open}>{t('cash.view')}</Button>
  </div>
}
